
/**
 * Modelo dos dados de um cliente
 */
class Cliente {

    /**
     * Cria uma nova instância de cliente
     * @param {Number} id Identificação do cliente
     * @param {String} nome Nome do cliente
     * @param {String} genero Gênero do cliente
     * @param {Date} dataNascimento Data de nascimento do cliente
     * @param {String} email E-mail do cliente
     */
    constructor(id, nome, genero, dataNascimento, email) {
        /** @member {Number} id Identificação do cliente */
        this.id = id ?? null;
        /** @member {String} nome Nome do cliente */
        this.nome = nome ?? null;
        /** @member {String} genero Gênero do cliente */
        this.genero = genero ?? null;
        /** @member {Date} dataNascimento Data de nascimento do cliente */
        this.dataNascimento = dataNascimento ?? null;
        /** @member {String} email E-mail do cliente */
        this.email = email;
    }

    /**
     * Copia os dados de um objeto
     * @param {Cliente} cliente Objeto a ser clonado
     * @returns {Cliente} Retorna um novo objeto com os mesmos dados
     */
    static clone(cliente) {
        let dataNascimento = null;
        if (cliente.dataNascimento)
            dataNascimento = new Date(cliente.dataNascimento);

        return new Cliente(cliente.id, cliente.nome, cliente.genero, dataNascimento, cliente.email);
    }
}

export default Cliente;